module.exports = __webpack_public_path__ + "app/community/community-info-1S2jlmm7.html";